import * as React from 'react'
import * as Yup from 'yup'
import { Formik, Form } from 'formik'
import { styled } from '@mui/material/styles'
import { Grid, Box, InputAdornment, Button, Alert } from '@mui/material'
import { AccountCircle } from '@mui/icons-material'
import { schema } from '../../utils/schemaValidation'
import Textfield from '../FormsUI/Textfield'

const ButtonCustom = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  textTransform: 'capitalize',
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '22px',
  fontSize: '0.9em',
  '&:hover': {
    backgroundColor: theme.palette.primary.light,
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}))

const boxStyle = {
  width: '100%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '25px',
  textAlign: 'center',
  borderRadius: '14px',
}

const EmailInputForm = ({ onSubmit, error }) => {
  const INITIAL_FORM_STATE = { email: '' }
  const FORM_VALIDATION = Yup.object().shape({ ...schema.EMAIL })

  return (
    <Box sx={boxStyle}>
      <Formik
        initialValues={{ ...INITIAL_FORM_STATE }}
        validationSchema={FORM_VALIDATION}
        onSubmit={async email => await onSubmit(email)}>
        <Form>
          <Grid container spacing={2} sx={{ pt: 0, width: '100%', ml: 0 }}>
            <Grid item xs={12} style={{ paddingLeft: 0 }}>
              <Textfield
                name="email"
                label="Correo electrónico"
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
                placeholder="user@example.com"
              />
            </Grid>
            {error && (
              <Grid item xs={12} style={{ paddingLeft: 0 }}>
                <Alert severity="error">
                  El usuario (correo electrónico) no se encuentra registrado.
                </Alert>
              </Grid>
            )}
            <Grid item xs={12} style={{ paddingLeft: 0 }}>
              <ButtonCustom variant="contained" fullWidth type="submit">
                Restuarar contraseña
              </ButtonCustom>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  )
}

export default EmailInputForm
